import React from 'react';
import { useProfilesList } from '../hooks/use-profiles-list.js';
import ProfilesPageView from './profiles-page-view.jsx';

function ProfilesPageContainer() {
  const state = useProfilesList();
  return <ProfilesPageView {...state} />;
}

export default ProfilesPageContainer;
